export const OPERATION_WIDTHS = [35, 25, 25, 10, 5]; // margin right

export const OPERATION_HEADER_COLUMNS = [
  { text: 'Тип', width: OPERATION_WIDTHS[0] },
  { text: 'Время запуска', width: OPERATION_WIDTHS[1] },
  { text: 'Время завершения', width: OPERATION_WIDTHS[2] },
  { text: 'Статус', width: OPERATION_WIDTHS[3] },
  { text: '', width: OPERATION_WIDTHS[4] },
];

